import { Injectable } from '@angular/core';
import { Observable, throwError, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import type { ExchangeFees, FiatFees } from 'src/app/models/exchange-fees';

@Injectable({
  providedIn: 'root'
})
export class FeesService {

  constructor(private api: ApiService, private auth: AuthService) { }

  getExchangeFees(): Observable<ExchangeFees> {
    const token = this.auth.getToken();

    return this.api.get(`{
      exchangeFees{
        tradeFees{
          pairs
          title
          steps{
            fromVolume{amount currency}
            toVolume{amount currency}
            makerFee
            takerFee
            makerFeeWithoutDiscount
            takerFeeWithoutDiscount
          }
          actualFeeStep{
            fromVolume{amount currency}
            toVolume{amount currency}
            makerFee
            takerFee
            makerFeeWithoutDiscount
            takerFeeWithoutDiscount
          }
          type
          feeDiscountPercent
          feeDiscountDateTo
        }
        withdrawalFees{
          currency
          amount{amount currency}
          minAmount{amount currency}
        }
        last30DaysUsdVolume{amount currency}
        last30DaysAedVolume{amount currency}
        last30DaysVolume{amount currency}
      }
    }`, null, token ? true : false).pipe(
      switchMap(response => {
        if (response['errors']) {
          return throwError(response);
        }

        return of(response['data']['exchangeFees']);
      }),
      this.api.unifyErrors()
    );
  }

  // TODO: fix mock
  getFiatFees(): Observable<FiatFees> {
    const token = this.auth.getToken();

    return this.api.get(`{
     fiatFees{
        withdrawalFees{
          currency
          amount
          flatAmount{amount currency}
          country
          fiatWithdrawalType
          supportedCurrencies
          additionalData{maxConnections}
        }
        depositFees{
          currency
          amount
          flatAmount{amount currency}
          country
          fiatDepositType
          supportedCurrencies
          additionalData{maxConnections}
        }
      }
    }`, null, !!token).pipe(
      switchMap(response => {
        if (response['errors']) {
          return throwError(response);
        }

        return of(response['data']['fiatFees']);
      }),
      this.api.unifyErrors()
    );
  }
}
